module.exports = __webpack_public_path__ + "static/media/not-attend.746bc1de.svg";